'use client'

import Link from "next/link"
import { useState } from "react"
import { useModal } from "../context/ModalContext"
import { useAuth } from "../context/AuthContext"
import LoginModal from "../context/modals/Login"

export default function FooterLink({ href, children }: { href: string, children: React.ReactNode }) {

    const [popinOpened, setPopinOpened] = useState(false)
    const { openModal, closeModal } = useModal()
    const { user } = useAuth()
    
	return (
		<>
            { user ? (
                <Link href={href}>
                    {children}
                </Link>
            ) : (
                <Link
                    href="#"
                    onClick={() => openModal(<LoginModal closeAction={closeModal} />)}
                >
                    {children}
                </Link>
            )}
        </>
	)
}